import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import useApi from "util/api"

import { GetBetsTableResponse, IBetsService } from "./type"

class BetsService implements IBetsService {
  // `id` is accepted (the shared Table component always passes it) but unused — these are
  // cross-user admin listings, mirroring transactionService.getTransactionsTable.
  public async getBetsTable(
    page: number,
    pageSize: number,
    _id: number | undefined,
    { createdAt }: { createdAt?: (Date | null)[] },
    sortRow?: string,
    sortOrder?: string
  ): Promise<GetBetsTableResponse | void> {
    const params = {
      page,
      pageSize,
      createdAt: createdAt || null,
      sortRow,
      sortOrder
    }
    const { data } = await useApi.get<IResponse<GetBetsTableResponse>>(REQ.ADMIN_DASHBOARD.BETS.GET, { params })

    if (data?.success) {
      return data?.response
    }
  }

  public async getBetbyBetsTable(
    page: number,
    pageSize: number,
    _id: number | undefined,
    { createdAt }: { createdAt?: (Date | null)[] },
    sortRow?: string,
    sortOrder?: string
  ): Promise<GetBetsTableResponse | void> {
    const params = {
      page,
      pageSize,
      createdAt: createdAt || null,
      sortRow,
      sortOrder
    }
    const { data } = await useApi.get<IResponse<GetBetsTableResponse>>(REQ.ADMIN_DASHBOARD.BETS.BETBY, { params })

    if (data?.success) {
      return data?.response
    }
  }
}

export const betsService = new BetsService()
